import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { supabase } from './supabaseClient';
import { Loader2 } from 'lucide-react';
import Landing from './pages/Landing';
import Dashboard from './Dashboard';
import NewProjectWizard from './NewProjectWizard';
import ProjectWorkspace from './ProjectWorkspace';
import Auth from './pages/AuthPage';
import Paywall from './pages/Paywall';
import Settings from './setting';
import Terms from './TermsOfService';
import Policy from './PrivacyPolicy';
import Links from './link_referral';
import Reset from './pages/ResetPasswordPage';
import Guide from './pages/Guide';

import Waitlist from './Waitlist';

import posthog from 'posthog-js';

// Init outside to prevent re-renders
posthog.init('phc_d1uHiZjVHj4EDkdXM4zpENykf5tl92mWn15DTgmLWTq', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
  capture_pageview: true,
});

const ProtectedRoute = ({ children }) => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false);
    });
    return () => subscription.unsubscribe();
  }, []);

  if (loading) return <div className="min-h-screen bg-slate-950 flex items-center justify-center"><Loader2 className="animate-spin text-blue-500 w-10 h-10" /></div>;
  if (!session) return <Navigate to="/auth" state={{ from: location }} replace />;
  return children;
};

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
	
    <Route path="/waitlist" element={<Waitlist />} />  
     
	  <Route path="/guide" element={<Guide />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Policy />} />
        <Route path="/links/:platform" element={<Links />} />
        <Route path="/reset-password" element={<Reset />} />
        
        <Route path="/console" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/pricing" element={<ProtectedRoute><Paywall /></ProtectedRoute>} />
        <Route path="/console/new" element={<ProtectedRoute><NewProjectWizard /></ProtectedRoute>} />
        <Route path="/console/project/:id" element={<ProtectedRoute><ProjectWorkspace /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
